import React, { useState, useEffect } from "react";
/** Components Import */
import BasicCombo from "../../Components/Combo_Basic";

function Login(props) {
  const [comboLabel, setComboLabel] = useState("언어");

  useEffect(() => {
    document.body.classList.add("bg-login-body");
    return () => {};
  }, []);

  useEffect(() => {
    ChangeLabel();
  }, [props.inputs.lang]);

  // User ID Click Event Func
  const SelectedIds = () => {
    const inputIds = document.getElementById("userId");
    inputIds.select();
    inputIds.focus();
  };

  // User Password Click Event Func
  const SelectedPws = () => {
    const inputPws = document.getElementById("userPw");
    inputPws.select();
    inputPws.focus();
  };

  const ChangeLabel = () => {
    switch (props.inputs.lang) {
      case "en":
        setComboLabel("Language");
        break;
      case "kr":
        setComboLabel("언어");
        break;
      case "vn":
        setComboLabel("ngôn ngữ");
        break;
      case "ch":
        setComboLabel("語言");
        break;
    }
  };

  return (
    <div className="loginCon with_bg">
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "30px",
        }}
      >
        <BasicCombo
          name={comboLabel}
          combos={props.combos}
          value={props.inputs.lang}
          onChange={(e) =>
            props.setInputs({
              ...props.inputs,
              lang: e,
            })
          }
        />
      </div>
      <h1 className="login_h1">하이텍정보</h1>
      <form action="" className="loginForm">
        <h2 className="login_h2">Dong Sung Printing</h2>
        <div className="input_set">
          <input
            id="userId"
            className="with_ico"
            type="text"
            placeholder="아이디"
            value={props.inputs.userid}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                userId: e.target.value,
              });
            }}
            onClick={SelectedIds}
          />
          <span className="ico_id"></span>
        </div>
        <div className="input_set">
          <input
            id="userPw"
            className="with_ico"
            type="password"
            placeholder="비밀번호"
            value={props.inputs.userPw}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                userPw: e.target.value,
              });
            }}
            onClick={SelectedPws}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                props.LoginLogic();
              }
            }}
          />
          <span className="ico_pw"></span>
        </div>
        <button
          className="btn_login"
          type="button"
          onClick={() => props.LoginLogic()}
        >
          로그인
        </button>
        <p className="copyright">
          COPYRIGHT (C) 2024 (주)하이텍정보. All Rights Reserved. Client
          version: 240119.01
        </p>
      </form>
    </div>
  );
}

export default Login;
